import ColourService from '@/shared/services/color';
import { SeriesConfig } from '@/features/reports/models';

export class ChartConfig {
	public static get gridChartsGlobalOptions(): Chart.ChartOptions {
		const options = ChartConfig.globalOptions;
		options.scales = {
				xAxes: [
				{
					ticks: {
						autoSkip: true,
						maxTicksLimit: 10
					},
					gridLines: {
						display: false
					}
				}
			]
		};
		options.plugins = {
			crosshair: {
				sync: {
					enabled: false
				},
				line: {
					color: 'red',
						width: 1
				},
				zoom: {
					enabled: false
				},
				snap: {
					enabled: true
				},
			}
		};
		return options;
	}

	public static get globalOptions(): Chart.ChartOptions {
		return {
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				position: 'right',
				// Uncomment to disable legend click event
				// onClick: () => { /**/ }
			},
			animation: {
				duration: 1000 // general animation time
			},
			hover: {
				intersect: false,
				animationDuration: 0 // duration of animations when hovering an item
			},
			responsiveAnimationDuration: 0, // animation duration after a resize
			tooltips: {
				mode: 'index',
				intersect: false,
				callbacks: {
					label: (tooltipItem: Chart.ChartTooltipItem) => {
						tooltipItem.value = this.formatNumber(tooltipItem.value as string);
						return tooltipItem.value;
					}
				}
			},
			plugins: {},
		};
	}

	public static backgroundPalette(orderedSeriesConfig: SeriesConfig[]): string[] {
		const palette = orderedSeriesConfig.map(config => {
			return config.colour || this.metricPalette[config.name] || this.metricPalette.Default;
		});
		return this.repeat(orderedSeriesConfig.length, palette.map(color => {
			if (color.startsWith('#')) {
				return ColourService.setAlpha(color, 0.2);
			}
		}));
	}

	public static borderPalette(orderedSeriesConfig: SeriesConfig[]): string[] {
		const palette = orderedSeriesConfig.map(config => {
			return config.colour || this.metricPalette[config.name];
		});
		return this.repeat(orderedSeriesConfig.length, palette.map(color => {
			return ColourService.darken(color, 1);
		}));
	}

	public static backgroundColoursForRandomItems(length: number): string[] {
		return [...this.unknownItemPalette].splice(0, length);
	}

	public static singleColourPalette(length: number, colour: string): string[] {
		return Array(length).fill(colour);
	}

	private static metricPalette: {[key: string]: string} = {
		Default: '#FF6666',
		Started: '#E6C300',
		Engaged: '#FF6666',
		Completed: '#062B80',
		HandedOver: '#FF6666',
		Leads: '#062B80',
		Users: '#FF6666',
		Conversations: '#062B80'
	};

	private static unknownItemPalette: string[] = [
		'#4A3B79',
		'#774674',
		'#BB566D',
		'#FF6666',
		'#F87F4A',
		'#EDAA1C',
		'#E6C300',
		'#A99A23',
		'#576251',
		'#43545D'
	];

	private static repeat<T>(length: number, array: T[]) {
		return Array(length).fill(array).flat();
	}

	private static formatNumber(value: string): string {
		const n = Number(value);
		if (isNaN(n)) {
			return value;
		}
		return n.toLocaleString();
	}
}

